export default "__VITE_ASSET__B3A0$XlD__"